import {
  Button,
  ButtonGroup,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

import SolidButton from '@/client/components/shared/buttons/SolidButton';

// TODO: Replace all confirmation modals with this component.

interface ConfirmationModalProps {
  /** Whether the modal is open or not. */
  isOpen: boolean;
  /** Function to close the modal. */
  onClose: () => void;
  /** The image source for the modal. */
  imageSrc: string;
  /** The title of the modal. */
  title: string;
  /** The first description of the modal. */
  descriptionOne: string;
  /** The second description of the modal. */
  descriptionTwo?: string;
  /** The options for the cancel button. Defaults to `{ label: 'Cancel', onClick: onClose }`. */
  cancelButtonOptions?: {
    /** The label for the cancel button. @default 'Cancel' */
    label?: string;
    /** Whether the cancel button is hidden or not. @default false */
    isHidden?: boolean;
    /** Function to click the cancel button. @default onClose */
    onClick?: () => void;
  };
  /** The options for the submit button. */
  submitButtonOptions: {
    /** The label for the submit button. */
    label: string;
    /** Function to click the submit button. */
    onClick: () => void;
    /** Whether the submit button is loading or not. */
    isLoading?: boolean;
  };
}

export default function ConfirmationModal({
  isOpen,
  onClose,
  imageSrc,
  title,
  descriptionOne,
  descriptionTwo,
  cancelButtonOptions = {
    label: 'Cancel',
    isHidden: false,
    onClick: () => onClose(),
  },
  submitButtonOptions,
}: ConfirmationModalProps) {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />

      <ModalContent>
        <ModalBody paddingTop={12}>
          <VStack textAlign="center">
            <Image src={imageSrc} width={120} height="auto" />

            <Text fontSize="20px" fontWeight={600} color="baseBlack">
              {title}
            </Text>

            <Text fontSize="14px" fontWeight={500} color="neutral.1000">
              {descriptionOne}
            </Text>

            {descriptionTwo && (
              <Text fontSize="14px" fontWeight={500} color="neutral.1000">
                {descriptionTwo}
              </Text>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter paddingX={10} paddingBottom={8} paddingTop={10}>
          <ButtonGroup width="full" alignItems="center" justifyContent="center">
            {!cancelButtonOptions.isHidden && (
              <Button variant="createCancel" onClick={cancelButtonOptions.onClick}>
                {cancelButtonOptions.label}
              </Button>
            )}

            <SolidButton
              isLoading={submitButtonOptions.isLoading}
              onClick={submitButtonOptions.onClick}
            >
              {submitButtonOptions.label}
            </SolidButton>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
